import { mapGetters } from 'vuex';
import DppCtaCardPresentational from './dpp-ctacard.presentational.vue';

export default {
    name: 'dppCtaCard',
    inject: ['$eventBus'],
    components: { DppCtaCardPresentational },
    computed: {
        ...mapGetters('glb', ['viewport', 'glb', 'getSplit']),
        ...mapGetters('dpp', ['dpp']),
    },
    props: {
        dppCtaInfo: {
            type: Object,
            default: function () {
                return null;
            },
        },
    },
    methods: {
        openAssignedAgentHotlead(options) {
            let buttonText = options.cta;
            let hotleadType = this.dppCtaInfo.hotleadType;
            this.$eventBus.$emit('dialog-center', {
                name: 'mvtHotleadForm',
                trigger: this.$options.name,
                opt: {
                    hotleadType,
                    propertyId: this.dpp.propertyId,
                    noSecondaryLead: true,
                    propertyData: this.dpp,
                    buttonText: buttonText,
                    hotleadTitle: 'Connect with an agent',
                    showComment: false,
                    hideVeteran: true,
                },
            });
            this.$eventBus.$emit('ga', { ec: 'dppsectionscta', en: 'click', el: options.section, props: { link_name: buttonText } });
        },
    },
};
